import { jsonToFormData } from '@core/utils/utils'
import crudActions from '@/store/crudActions'
import axios from '@/libs/axios'

const endpoint = 'apply-document'
const Actions = crudActions(endpoint)

const organizations = ({ commit }) => new Promise((resolve, reject) => {
  axios.get('/organizations/university_list/')
    .then(response => {
      commit('ORGANIZATIONS', response.data)
      resolve(response)
    })
    .catch(error => {
      console.log(error)
      reject(error)
    })
})
const directions = ({ commit }, queryParams) => new Promise((resolve, reject) => {
  axios.get('/org-directions/', { params: queryParams })
    .then(response => {
      commit('DIRECTIONS', response.data.results)
      resolve(response)
    })
    .catch(error => {
      console.log(error)
      reject(error)
    })
})

// eslint-disable-next-line no-unused-vars
const uploadFile = ({ commit }, data) => new Promise((resolve, reject) => {
  const key = [...data.body][0][0]
  let action = 'upload_file'
  if (key === 'language_certificate') {
    action = 'change_lang_certificate'
  }
  axios.patch(`${endpoint}/${data.id}/${action}/`, data.body, {
    onUploadProgress: data.onUploadProgress,
  })
    .then(response => {
      resolve(response)
    })
    .catch(error => {
      console.log(error)
      reject(error)
    })
})
const list = ({ commit }, queryParams) => new Promise((resolve, reject) => {
  axios.get(`/${endpoint}/`, { params: queryParams })
    .then(response => {
      commit('LIST', response.data.results)
      resolve(response)
    })
    .catch(error => {
      console.log(error)
      reject(error)
    })
})
const regenerate = (ctx, id) => new Promise((resolve, reject) => {
  axios.get(`/${endpoint}/${id}/regenerate-apply-document/`)
    .then(response => {
      resolve(response.data)
    })
    .catch(error => {
      console.log(error)
      reject(error)
    })
})

const manage = (ctx, applyDoc) => new Promise((resolve, reject) => {
  axios.patch(`/${endpoint}/${applyDoc.id}/change_failed_docs/`, {
    dc_type: applyDoc.dc_type,
    direction_id: applyDoc.direction,
    is_participated_exam: applyDoc.is_participated_exam,
  })
    .then(response => {
      resolve(response.data)
    })
    .catch(error => {
      console.log(error)
      reject(error)
    })
})

const oldCreate = (ctx, data) => axios.post('/old-apply-documents/old-apply/', jsonToFormData(data))
const oldUpdate = (ctx, data) => axios.post(`/old-apply-documents/${data.id}/old-apply/`, jsonToFormData(data))
const oldConfirm = (ctx, id) => axios.post(`/old-apply-documents/${id}/old-apply-confirm/`)
const oldReject = (ctx, data) => axios.post(`/old-apply-documents/${data.id}/old-apply-reject/`, data)
const oldDelete = (ctx, id) => axios.delete(`/old-apply-documents/${id}/old-apply-delete/`)

const changeBannedFile = (_, data) => {
  const formData = new FormData()
  formData.append('banned_file', data.file)
  return axios.patch(`/${endpoint}/${data.id}/change_banned_file/`, formData)
}

const changePhdDscDiplom = (_, data) => {
  const formData = new FormData()
  formData.append('phd_dsc_diplom', data.file)
  return axios.patch(`/${endpoint}/${data.id}/change_phd_dsc_diplom/`, formData)
}
const vacation = (_, data) => {
  const formData = new FormData()
  formData.append('file', data.file)
  formData.append('description', data.description)
  return axios.post(`/${endpoint}/${data.id}/change_academic_vacation_status/`, formData)
}

const changeToDraft = (_, data) => axios.patch(`/${endpoint}/${data.id}/change_to_draft/`)
const filterByPassport = (ctx, queryParams) => axios.get('/old-apply-documents/filter-by-passport/', { params: queryParams })
const history = ({ commit }, id) => axios.get(`/${endpoint}/${id}/user-apply-documents/`)
  .then(response => {
    commit('HISTORY', response.data)
    return response
  })
Actions.list = list
export default {
  ...Actions,
  organizations,
  directions,
  uploadFile,
  regenerate,
  manage,
  changeBannedFile,
  changePhdDscDiplom,
  changeToDraft,
  vacation,
  filterByPassport,
  history,
  oldCreate,
  oldUpdate,
  oldConfirm,
  oldDelete,
  oldReject,
}
